import { FormattedNumber, useIntl } from 'react-intl';
import { formatCompactNumber } from '@_/utils';

interface FormattedNumProps {
  compact?: boolean;
  value: number | string;
}

export function FormattedNum({ compact = false, value }: FormattedNumProps) {
  const { locale } = useIntl();

  return compact ? (
    <>{formatCompactNumber(locale, value)}</>
  ) : (
    <FormattedNumber useGrouping value={typeof value === 'string' ? parseInt(value, 10) : value} />
  );
}
